<template>
  <div>
    <el-table :data="logList" :border="true" max-height="400px" size="small" tooltip-effect="dark">
      <el-table-column prop="createTime" label="操作时间" width="150" />
      <el-table-column prop="operator" label="操作方" width="150">
        <template slot-scope="scope">
          {{ scope.row.operator || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="operatorUser" label="操作人" width="150">
        <template slot-scope="scope">
          <yd-link
            v-if="scope.row.operator === '系统管理员-后台'"
            :value="scope.row.operatorUser"
            :type="'systemUser'"
            :query="{ userId: scope.row.unionUserId }"
          />
          <yd-link
            v-else-if="scope.row.operator === '用户'"
            permi="user_center_manage"
            :value="scope.row.operatorUser"
            :url="`/customer/user/index/${scope.row.operatorUser}/${scope.row.unionUserId}`"
            type="userInfo"
            :need="true"
          />
          <span v-else>{{ scope.row.operatorUser }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operateType" label="操作类型" width="150">
        <template slot-scope="scope">
          {{ scope.row.operateType || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="operateContent" label="操作内容" />
      <el-table-column prop="sourceOperateContent" label="原内容" />
    </el-table>
  </div>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  logList: {
    type: Array,
    default: () => []
  }
};
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
